import _ from 'lodash'
import Service from '../../models/Service.model'

// test: jest src/utils/booking/__tests__/ServiceDataFetcher.test.js
export default class ServiceDataFetcher {
  constructor() {
    this._services = []
    this._isFetching = false
  }

  injectCollectionApi(collectionApi) {
    this.collectionApi = collectionApi
  }

  setServiceFieldMappings(fieldMappings) {
    this.serviceFieldMappings = fieldMappings
  }

  get isFetching() {
    return this._isFetching
  }

  get services() {
    return this._services
  }

  async fetchServices(collectionId) {
    if (!collectionId) {
      console.warn('[ServiceDataFetcher] collectionId is not provided. Calling for fetchServices() is skipped.')
      this._services = []
      return []
    }
    if (!this.serviceFieldMappings) {
      console.warn('[ServiceDataFetcher] serviceFieldMappings is not provided. Calling for fetchServices() is skipped.')
      this._services = []
      return []
    }
    this._isFetching = true
    try {
      this._services = _.get(await this.collectionApi.getCollection(collectionId), 'data.data.items', [])
        .map(item => Service.fromCollectionItem(item, this.serviceFieldMappings))
    } finally {
      this._isFetching = false
    }
    return this._services
  }

  async fetchServicesByBranch(collectionId, branchId) {
    if (!collectionId || !branchId) {
      console.warn('[ServiceDataFetcher] collectionId or branchId is not provided. Calling for fetchServicesByBranch() is skipped.')
      this._services = []
      return []
    }
    if (!this.serviceFieldMappings) {
      console.warn('[ServiceDataFetcher] serviceFieldMappings is not provided. Calling for fetchServicesByBranch() is skipped.')
      this._services = []
      return []
    }
    this._isFetching = true
    try {
      this._services = _.get(await this.collectionApi.getOptionsForBranch(collectionId, branchId), 'data.data.items', [])
        .map(item => Service.fromCollectionItem(item, this.serviceFieldMappings))
    } finally {
      this._isFetching = false
    }
    return this._services
  }

  async fetchServicesByStaff(collectionId, staffId) {
    if (!collectionId || !staffId) {
      console.warn('[ServiceDataFetcher] collectionId or staffId is not provided. Calling for fetchServicesByStaff() is skipped.')
      this._services = []
      return []
    }
    if (!this.serviceFieldMappings) {
      console.warn('[ServiceDataFetcher] serviceFieldMappings is not provided. Calling for fetchServicesByStaff() is skipped.')
      this._services = []
      return []
    }
    this._isFetching = true
    try {
      this._services = _.get(await this.collectionApi.getOptionsForStaff(collectionId, staffId), 'data.data', [])
        .map(item => Service.fromCollectionItem(item, this.serviceFieldMappings))
    } finally {
      this._isFetching = false
    }
    return this._services
  }
}
